

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class WeightLabel extends Vue {
  @Prop({
    default: 'standard'
  })
  public unit!: string;

  @Prop({
    default: 0
  })
  public kgValue!: number;

  @Prop({
    default: null
  })
  public lbValue!: object;

  @Prop({
    default: 0
  })
  public lbValueDecimal!: number;

  @Prop({
    default: false
  })
  public abbreviated!: boolean;

  @Prop({
    default: false
  })
  public withBreak!: boolean;

  @Prop({
    default: false
  })
  public double!: boolean;

  get lbValueDecimalFormatted() {
    return this.lbValueDecimal.toFixed(1);
  }

  get kgValueDecimalFormatted() {
    return this.kgValue.toFixed(1);
  }

}
